import script from "./ApplicationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationPage.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationPage.vue?vue&type=style&index=0&id=7e4a3866&lang=css"

const __exports__ = script;

export default __exports__